export default __webpack_public_path__ + "assets/helpi_spinner.gif";